import { AREAS, locationByCode } from '@/lib/locations'
import { cn } from '@/lib/utils'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'
import { Flag } from '@/components/flag'

/** Region checks: every check location by area, with flags (home, "Only confirmed outages" chapter). */
export function RegionChecks({ className }: { className?: string }) {
  return (
    <div className={cn('rounded-lg border border-border bg-card', className)}>
      <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 px-5 py-4">
        <h3 className="font-semibold text-foreground">Region checks on every paid plan</h3>
        <p className="text-sm text-muted-foreground">
          {MONITOR_LOCATIONS.regionList.right}
        </p>
      </div>
      <ul className="grid sm:grid-cols-2">
        {AREAS.map((area) => (
          <li key={area.name} className="border-t border-border px-5 py-3 sm:odd:border-r">
            <div className="text-sm text-muted-foreground">{area.name}</div>
            <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-[15px] text-body">
              {area.codes.map((code) => {
                const l = locationByCode(code)
                return l ? (
                  <span key={code} className="inline-flex items-center gap-1.5">
                    <Flag flag={l.flag} />
                    {l.city}
                    {!l.core && MONITOR_LOCATIONS.regionList.tag && (
                      <span className="text-xs text-muted-foreground">({MONITOR_LOCATIONS.regionList.tag})</span>
                    )}
                  </span>
                ) : null
              })}
            </div>
          </li>
        ))}
      </ul>
      <p className="border-t border-border px-5 py-3 text-sm text-body">
        {MONITOR_LOCATIONS.regionList.footer}
      </p>
    </div>
  )
}
